module.exports = __webpack_public_path__ + "fonts/remixicon.18d83c3a.eot";